import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';

import App from '@/app';
import { AuthProvider } from '@/contexts/AuthContext';
import theme from '@/theme';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

ReactDOM.render(
    <React.StrictMode>
        <HelmetProvider>
            <ChakraProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                        <App />
                    </AuthProvider>
                </QueryClientProvider>
            </ChakraProvider>
        </HelmetProvider>
    </React.StrictMode>,
    document.getElementById('root')
);